// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PieChartTwoToneSvg from "@ant-design/icons-svg/es/asn/PieChartTwoTone";
import AntdIcon from '../components/AntdIcon';

var PieChartTwoTone = function PieChartTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PieChartTwoToneSvg
  }));
};

PieChartTwoTone.displayName = 'PieChartTwoTone';
export default React.forwardRef(PieChartTwoTone);